import {FolderOutlined} from '@mui/icons-material';
import {AddCircle} from '@mui/icons-material';
import {useCan, usePersona} from 'src/permissions/hooks';
import {Box, Button, Typography} from '@mui/material';
import {FC, useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {Table} from 'src/components/tables/Table';
import {FilterBar} from 'src/components/common/FilterBar';
import {TableLayout} from 'src/components/tables/TableLayout';
import {AddFileToLocation} from '../AddFileToLocation';
import {columnConfigLocationFiles, columnConfigLocationFilesSm,} from './LocationFiles.tableConfig';
import {LocationFilesType} from './LocationFiles.types';
import {tableSx} from './LocationFiles.sx';
import {addRowSx} from 'src/components/tables/TableLayout/TableLayout.sx';
import {ResponsiveTable} from '../../common/ResponsiveTable';

export const LocationFiles: FC<LocationFilesType> = ({data, title}) => {
    const intl = useIntl();
    const [open, setOpen] = useState<boolean>(false);
    const persona = usePersona();

    const isCompanyUser = persona.isCompany;
    const canAddFile = useCan('locationFiles.create');
    const isEmployeeUser = persona.isEmployee;
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <TableLayout
                toolbar={(
                    <FilterBar
                        title={title}
                        icon={<FolderOutlined/>}
                        subtitle={intl.formatMessage({id: 'rowsFound'}, {count: data.files?.length ?? 0})}
                    />
                )}
                /* The permission the upload endpoint checks. Naming two personas that may not upload
                   left out everyone else who may not either, and hid nothing from those who may. */
                footerPadded={false}
                footer={
                    canAddFile && (
                        <Button
                            sx={addRowSx}
                            onClick={handleOpen}
                        >
                            <AddCircle/>
                            <FormattedMessage id="addFile"/>
                        </Button>
                    )
                }
            >
                <ResponsiveTable
                    responsiveElement={
                        <Table
                            sx={tableSx}
                            onCellClick={(params, events) =>
                                (params.field === 'delete' || params.field === 'delete') && events.stopPropagation()
                            }
                            headerHeight={0}
                            checkboxSelection={false}
                            rows={data.files}
                            columns={columnConfigLocationFilesSm(persona.isPlatformAdmin)}
                            hideFooter
                        />
                    }
                    desktopElement={
                        <Table
                            sx={tableSx}
                            onCellClick={(params, events) =>
                                (params.field === 'delete' || params.field === 'delete') && events.stopPropagation()
                            }
                            headerHeight={0}
                            checkboxSelection={false}
                            rows={data.files}
                            columns={columnConfigLocationFiles(persona.isPlatformAdmin)}
                            hideFooter
                        />
                    }
                />
            </TableLayout>
            <AddFileToLocation
                handleClose={handleClose}
                open={open}
                locationId={data.id}
                businessId={data.business.id}
            />
        </>
    );
};
